// unsubscribeApi.js
import axiosInstance from './axiosInstance';

const unsubscribeApi = {
  checkCode: (code) => axiosInstance.post('/unsubscribe/check', { code }),
  cancelSubscription: (email, code) =>
    axiosInstance.post('/unsubscribe/cancel', { email, code }),
};

export default unsubscribeApi;
